export { default } from "./CompleteReportPill";
